//#region src/bustedReload.ts
function e(e) {
	let t = e.indexOf("#"), n = t === -1 ? "" : e.slice(t), r = t === -1 ? e : e.slice(0, t), i = r.indexOf("?"), a = i === -1 ? r : r.slice(0, i), o = (i === -1 ? "" : r.slice(i + 1)).split("&").filter((e) => e && !e.startsWith("cb="));
	return o.push(`cb=${Date.now()}`), `${a}?${o.join("&")}${n}`;
}
function t() {
	if (typeof window > "u" || !window.location) return;
	let { location: t } = window;
	t.replace(e(t.pathname + t.search + t.hash));
}
//#endregion
export { e as appendCacheBust, t as bustedReload };
